module.exports = __webpack_public_path__ + "img/unsubscribe-gray.32544ad1.svg";